import React from 'react';
import PropTypes from 'prop-types';

import Table from '../table/table';
import Product from '../product/product';
import ImageGallery from '../imageGallery/imageGallery';

const TableTypes = [
  'PrismicStronaBodyTabela',
  'PrismicStronaKategoriiBodyTabela',
];

const ProductTypes = [
  'PrismicStronaBodyProdukt',
  'PrismicStronaKategoriiBodyProdukt',
];

const ImageTypes = [
  'PrismicStronaBodyZdjecie',
  'PrismicStronaKategoriiBodyZdjecia',
];

const SliceZone = ({ slices }) =>
  slices &&
  slices.length &&
  slices.map((s, index) => {
    const typeName = s.__typename || s.internal.type;

    switch (true) {
      case TableTypes.some(type => typeName.includes(type)):
        return (
          <Table
            key={s.id}
            data={JSON.parse(s.primary.kod_tabeli.text)}
            data-aos="fade-up"
            data-aos-delay="400"
          />
        );

      case ProductTypes.some(type => typeName.includes(type)):
        return (
          <Product
            key={s.id}
            title={s.primary.tytul.text}
            image={s.primary.zdjecie}
            description={s.primary.opis.html}
            css="margin-top: 60px;"
            data-aos="fade-up"
            data-aos-delay={100 + index * 100}
          />
        );

      case ImageTypes.some(type => typeName.includes(type)):
        return (
          <ImageGallery
            key={s.id || s.prismicId}
            images={s.items}
            css="margin-top: 60px;"
            data-aos="fade-up"
            data-aos-delay="100"
          />
        );

      default:
        return null;
    }
  });

SliceZone.propTypes = {
  slices: PropTypes.array,
};

export default SliceZone;
